<select class="form-select" id="timezoneSelect" [formControl]="timezone" aria-label="Timezone"
    (change)="onSelectionChange($event)" (blur)="onBlur()">

    @for (tz of timezonesList(); track tz.id) {
        <option [value]="tz.id">{{tz.displayName}}</option>
    }
</select>
